import { render, staticRenderFns } from "./MyOperationsRequests.vue?vue&type=template&id=36b36170&"
import script from "./MyOperationsRequests.vue?vue&type=script&lang=ts&"
export * from "./MyOperationsRequests.vue?vue&type=script&lang=ts&"
import style0 from "./MyOperationsRequests.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports